import apiClient from "../utils/apiClient";
import { useState, useEffect } from "react";
import BreakManager from "./BreakManager";

function AdminDay({ data }) {    
    // Set state using data prop, ensuring it updates when data changes
    const [isAvailable, setIsAvailable] = useState(data.available);
    const [fromTime, setFromTime] = useState(data.from || '09:00');
    const [toTime, setToTime] = useState(data.to || '17:00');
    // Reset component state when data.id or data.available changes
    useEffect(() => {
        setIsAvailable(data.available);
        setFromTime(data.from || '09:00');
        setToTime(data.to || '17:00');
    }, [data.id, data.available, data.from, data.to]);
    const [showBreaks, setShowBreaks] = useState(false);

    async function handleAvailabilityChange() {
        try {
            const response = await apiClient.put(
                `/termins/${data.id}`,
                {
                    available: !isAvailable,
                    from: fromTime,
                    to: toTime
                }
            );
            setIsAvailable(!isAvailable);
        } catch (error) {
            setIsAvailable(isAvailable);
        }
    }

    async function handleTimeUpdate() {
        try {
            const roundedFromTime = new Date(Math.ceil(new Date("1970-01-01T" + fromTime + "Z").getTime() / 1800000) * 1800000).toISOString().substr(11, 5);
            const roundedToTime = new Date(Math.ceil(new Date("1970-01-01T" + toTime + "Z").getTime() / 1800000) * 1800000).toISOString().substr(11, 5);

            await setFromTime(roundedFromTime);
            await setToTime(roundedToTime);

            const response = await apiClient.put(
                `/termins/${data.id}`,
                {
                    from: roundedFromTime,
                    to: roundedToTime
                }
            );
        } catch (error) {
            console.error('Time update failed:', error.response?.data || error.message);
        }
    }

    // Format time to ensure 24-hour format
    const formatTimeValue = (time) => {
        if (!time) return '';
        return time.length === 5 ? time : `0${time}`.slice(-5);
    };

    const translateDayToSlovenian = (englishDay) => {
        const dayTranslations = {
            'Sunday': 'Nedelja',
            'Monday': 'Ponedeljek',
            'Tuesday': 'Torek',
            'Wednesday': 'Sreda',
            'Thursday': 'Četrtek',
            'Friday': 'Petek',
            'Saturday': 'Sobota'
        };
        return dayTranslations[englishDay] || englishDay;
    };

    return (
        <div className={`day-toggle-btn ${isAvailable ? 'active' : ''}`}>
            <div className="day-header">
                <span className="day-name">{translateDayToSlovenian(data.day)}</span>                <span className="day-date">
                    {new Date(data.date).toLocaleDateString('sl-SI')}
                </span>

                <div className="time-range-container">
                    <input
                        type="time"
                        value={formatTimeValue(fromTime)}
                        onChange={(e) => setFromTime(e.target.value)}
                        onBlur={handleTimeUpdate}
                        disabled={!isAvailable}
                        className="time-input"
                    />
                    <span className="time-separator">–</span>
                    <input
                        type="time"
                        value={formatTimeValue(toTime)}
                        onChange={(e) => setToTime(e.target.value)}
                        onBlur={handleTimeUpdate}
                        disabled={!isAvailable}
                        className="time-input"
                    />
                </div>                <label className="day-status-checkbox">
                    <input
                        type="checkbox"
                        className="day-status-toggle"
                        checked={isAvailable}
                        onChange={handleAvailabilityChange}
                    />
                    <span className="checkbox-label">
                        {isAvailable ? 'NA VOLJO' : 'NI NA VOLJO'}
                    </span>
                </label>

                {isAvailable && (
                    <button 
                        className="breaks-toggle-btn"
                        onClick={() => setShowBreaks(!showBreaks)}
                        type="button"
                    >
                        {showBreaks ? 'Skrij odmore' : 'Upravljaj odmore'}
                    </button>
                )}
            </div>

            {showBreaks && isAvailable && (
                <div className="breaks-section">
                    <BreakManager 
                        date={new Date(data.date)} 
                        workingHours={{ from: fromTime, to: toTime }}
                    />
                </div>
            )}
        </div>
    );
}

export default AdminDay;